import { useCallback, useContext } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { useGetVehicleId } from '~/context/vdp/VehicleContext';
import {
  type FavoritesArguments,
  type LifeCycleFn,
  useAddFavorite as useAddFavoriteCommon
} from '~/hooks/common/favorites';

export function useBeforeAddFavorite() {
  const { setFavorite } = useContext(UserVehicleContext);
  const currentVehicleId = useGetVehicleId();

  return useCallback(
    ({ vehicleId }: FavoritesArguments) => {
      if (currentVehicleId === vehicleId) {
        setFavorite(true);
      }
    },
    [currentVehicleId, setFavorite]
  );
}

type Options = {
  onAddFavorite?: LifeCycleFn;
};

export default function useAddFavorite(
  opts: Options = {}
): (args: FavoritesArguments) => Promise<void> {
  return useAddFavoriteCommon({
    beforeAddFavorite: useBeforeAddFavorite(),
    onAddFavorite: opts.onAddFavorite
  });
}
